import { api } from "../../../../../../utils/api";

const VAPID_PUBLIC_KEY =
  "BAJfzGNwjKa90lJPqb8_8NF837zoS35MvaVObOtbPq80EX7i1fw1QMZi-DIDUiFgT8TylZjex8SD2HpndaSQpnU";

export const subscribeToPush = async (): Promise<PushSubscription | null> => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    console.warn("Service Worker or Push not supported");
    return null;
  }

  // Попросити дозвіл
  if (Notification.permission === "default") {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission denied");
      return null;
    }
  } else if (Notification.permission === "denied") {
    console.warn("Notification permission denied");
    return null;
  }

  const registration = await navigator.serviceWorker.ready;

  let subscription = await registration.pushManager.getSubscription();

  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });
    console.log("New Push Subscription created");
  } else {
    console.log("Push Subscription already exists");
  }

  // Відправка на бекенд
  await api.post("/web-request/subscribe", subscription);
  localStorage.setItem("push_subscribed", "1");

  return subscription;
};

// Конвертер VAPID ключа
function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

interface PushPayload {
  subscription: PushSubscription;
  title: string;
  body: string;
  image?: string;
  timeDelay: number;
}

export const sendPushNotification = async ({
  subscription,
  title,
  body,
  image,
  timeDelay,
}: PushPayload) => {
  try {
    await api.post("/web-request/push-notification", {
      subscription,
      title,
      body,
      image,
      timeDelay,
    });
    console.log("Notification sent to backend");
  } catch (error) {
    console.error("Failed to send notification to backend", error);
  }
};

export const unsubscribeFromPush = async (): Promise<void> => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;

  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();

  if (subscription) {
    await subscription.unsubscribe();
    console.log("Push subscription removed");
    // При бажанні повідомити бекенд про видалення
    // await api.post("/web-request/unsubscribe", subscription);
    localStorage.removeItem("push_subscribed");
  }
};